/**
 * 身分世代守衛（純函式）。契約與判定序列見 spec/JT-1784889480_identity-generation-invariant.md §5.3～§5.4。
 */

export const isNonEmptyString = (value) => typeof value === 'string' && value.length > 0

/**
 * 由 token 導出不可逆身分識別碼（FNV-1a 32-bit → 8 位 hex）。
 * 原始 token 是可重放憑證，不得進入 Pinia state / localStorage / Sentry payload（BR-4）。
 *
 * @param {string|null|undefined} token
 * @returns {string|null} 8 位 hex；無身分時為 null
 */
export const identityKey = (token) => {
  if (!isNonEmptyString(token)) {
    return null
  }

  let hash = 0x811c9dc5
  for (let i = 0; i < token.length; i += 1) {
    hash ^= token.charCodeAt(i)
    hash = Math.imul(hash, 0x01000193)
  }

  return (hash >>> 0).toString(16).padStart(8, '0')
}

/**
 * 身分世代是否變更。只認「非空 → 不同的非空」。
 *
 * @param {string|null|undefined} previousToken 最後一個非空 token（不是上一個 tick 的值）
 * @param {string|null|undefined} nextToken
 * @returns {boolean}
 */
export const hasIdentityChanged = (previousToken, nextToken) => {
  if (!isNonEmptyString(previousToken) || !isNonEmptyString(nextToken)) {
    return false
  }
  return previousToken !== nextToken
}

/**
 * 領獎歸屬校驗。fail-open：沒有蓋章就放行（BR-3）——誤擋正常領獎的損害大於漏擋，
 * 且漏擋仍有後端把關（後端 SQL 一律綁 uid_site）。
 *
 * @param {object} params
 * @param {string|null} params.currentKey  當下 token 的 identityKey
 * @param {string|null} params.rowOwnerKey 該筆獎勵寫入時蓋的章（優先）
 * @param {string|null} params.listOwnerKey 整份清單寫入時蓋的章（退而求其次）
 * @returns {boolean}
 */
export const isRewardClaimAllowed = ({ currentKey, rowOwnerKey, listOwnerKey } = {}) => {
  if (!isNonEmptyString(currentKey)) {
    return true
  }
  if (isNonEmptyString(rowOwnerKey)) {
    return rowOwnerKey === currentKey
  }
  if (isNonEmptyString(listOwnerKey)) {
    return listOwnerKey === currentKey
  }
  return true
}
